<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->
    <!-- Form -->
    <v-container grid-list-md>
      <v-flex xs12>
        <v-card style="margin-bottom:10px">
          <v-card-title>
            <span class="title">Early Settlement</span>
          </v-card-title>
          
          <v-form v-model="valid" ref="form1" lazy-validation>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4 class="pr-4">
                    <DatePicker
                      :key="formSchema.id"
                      :inputData="{index:1,fieldName:'installment_date', fieldValue:formSchema.installment_date, label:'Settlement Date *', required:1}"
                      @setValue="setDateValue"
                    ></DatePicker>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-autocomplete
                      label="Loan Number *"
                      item-text="loan_no"
                      item-value="id"
                      v-model="formSchema.loan_id"
                      :items="profileList"
                      :rules="[v => !!v || 'Field is required']"
                      @change="setProfileData"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      label="Sub-Project Name"
                      v-model="sub_project_name"
                      readonly
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      label="Re Schedule No."
                      v-model="formSchema.re_schedule_no"
                      readonly
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field label="Reset No." v-model="formSchema.reset_no" readonly></v-text-field>
                  </v-flex>

                  

                  <v-flex xs12 sm12 md12>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="success" flat @click.native="getEarlySettlementForm">
                      <v-icon>save</v-icon>Search
                    </v-btn>
                    </v-card-actions>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-form>
        </v-card>

        <v-card v-if="profileForm">

          <v-btn color="primary" v-on:click="printdiv" style="float:right">
            <v-icon>print</v-icon> Print
          </v-btn>

          </br>
          <div id="print-area">

            <table class="paySchedule top">
              <tbody>
                <tr class="textCenter">
                  <th>Loan No</th>
                  <th colspan="2" style="font-size: 16px;">{{ formSchema.loan_no }}</th>
                </tr>
                <tr class="tb-td">
                  <th>Adjustment Type</th>
                  <th style="font-size: 16px;">  Early Setting </th>
                </tr>

              </tbody>
            </table>
            </br>
            <table class="paySchedule">
              <tbody v-if="formSchema.unpaid_installment && formSchema.unpaid_installment.length>0">
                <tr class="textCenter">
                  <th colspan="7" style="font-size: 20px;">Unpaid Installment Calculation</th>
                </tr>
                <tr class="tb-td">
                  <th>Due Installment Date</th>
                  <th>Principal</th>
                  <th> Interest</th>
                  <th> Installment Size</th>
                  <th>Over Due Days</th>
                  <th>Over Due Interest</th>
                  <th> Total Installment </th>
                </tr>
                <!-- __________________ Debit Row _________________ -->
                <tr v-for="(inst_data, index) in formSchema.unpaid_installment" :key=index>
                  
                  <td class="textCenter">
                    {{dateStringMonth(inst_data.installment_date)}}
                  </td>
                  <td class="textCenter">
                    {{inst_data.unpaid_principal | currency}}
                  </td>
                  <td class="textCenter">
                    {{inst_data.unpaid_interest | currency}}
                  </td>
                  <td class="textCenter">
                    {{inst_data.intallmentSize | currency}}
                  </td>
                  <td class="textCenter">
                    {{inst_data.total_Days}}
                  </td>
                  <td class="textCenter">
                    {{inst_data.dueInterest | currency}}
                  </td>
                  <td class="textCenter">
                    {{inst_data.total_size | currency}}
                  </td>
                </tr>
                <!-- __________________ /Debit Row _________________ -->
                <tr >
                  <th  class="textRight">Total Due Installment</th>
                  <th> {{formSchema.total_unpaid_principal | currency}} </th>
                  <th> {{formSchema.total_unpaid_interest | currency}} </th>
                  <th></th>
                  <th></th>
                  <th> {{formSchema.total_dueInterest | currency}} </th>
                  <th> {{formSchema.sum_installment | currency}} </th>
                </tr>


              </tbody>
            </table>
            <hr>
            </br>
            <table class="paySchedule">
              <tbody v-if="formSchema.partialPayData && formSchema.partialPayData.length>0">
                <tr class="textCenter">
                  <th colspan="7" style="font-size: 20px;">Adjust Partial Payment</th>
                </tr>
                <tr class="tb-td">
                  <th>Recieve Date</th>
                  <th>Principal</th>
                  <th> Interest</th>
                  <th>Pay Amount</th>
                  <th>Total Days</th>
                  <th> Reduce Interest Amount </th>
                  <th> Total Partial Pay Amount </th>
                </tr>
                <!-- __________________ Debit Row _________________ -->
                <tr v-for="(pay_data, index) in formSchema.partialPayData" :key=index>
                  
                  <td class="textCenter">
                    {{dateStringMonth(pay_data.receive_date )}}
                  </td>
                  <td class="textCenter">
                    {{pay_data.principal | currency}}
                  </td>
                  <td class="textCenter">
                    {{pay_data.interest | currency}}
                  </td>
                  <td class="textCenter">
                    {{pay_data.payAmount | currency}}
                  </td>
                  <td class="textCenter">
                    {{pay_data.totalDay}}
                  </td>
                  <td class="textCenter">
                    {{pay_data.reduceInterest | currency}}
                  </td>
                  <td class="textCenter">
                    {{pay_data.total_partial_amount | currency}}
                  </td>
                </tr>
                <!-- __________________ /Debit Row _________________ -->
                <tr >
                  <th class="textRight">Total Partial Pay Amount</th>
                  <th> {{formSchema.total_partial_principal | currency}} </th>
                  <th> {{formSchema.total_partial_interest | currency}} </th>
                  <th></th>
                  <th></th>
                  <th> {{formSchema.total_reduce_interest | currency}} </th>
                  <th> {{(formSchema.partialPayData) ? formSchema.partialPayData[0].sum_partial_amount : 0 | currency}} </th>
                </tr>


              </tbody>
            </table>
            <hr>
            </br>
            <table class="paySchedule">
              <tbody>
                <tr class="textCenter">
                  <th colspan="8" style="font-size: 20px;">Outstanding Calculation</th>
                </tr>
                <tr class="tb-td">
                  <th>Last Installment Date</th>
                  <th> Outstanding <br> (A) </th>
                  <th style="padding:0px;">Extra Days</th>
                  <th> Extra Interest <br> (B) </th>
                  <th> Due Installment <br> (C) </th>
                  <th> Partial Amount <br> (D) </th>
                  <th>Total Outstanding <br> (A+B+C) - (D)</th>
                </tr>
                <!-- __________________ Debit Row _________________ -->
                <tr>
                  
                  <td class="textCenter">
                    {{dateStringMonth(formSchema.lastInstallment_date)}}
                  </td>
                  <td class="textCenter">
                    {{formSchema.main_principal | currency}}
                  </td>

                  <td class="textCenter">
                    {{formSchema.total_Days}}
                  </td>
                  <td class="textCenter">
                    {{formSchema.extra_interest | currency}}
                  </td>
                  <td class="textCenter">
                    {{formSchema.sum_installment | currency}}
                  </td>
                  <td class="textCenter">
                    {{(formSchema.partialPayData && formSchema.partialPayData.length > 0) ? formSchema.partialPayData[0].sum_partial_amount : 0 | currency}}
                  </td>
                  <td class="textCenter">
                    {{formSchema.outstanding | currency}}
                  </td>
                </tr>
                <!-- __________________ /Debit Row _________________ -->

              </tbody>
            </table>
          </div>  

          <br>
          <hr>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md3 class="pr-4">
                    <DatePicker
                      :key="formSchema.id"
                      :inputData="{index:1,fieldName:'installment_date', fieldValue:formSchema.installment_date, label:'Settlement Date *', required:1}"
                      @setValue="setDateValue"
                    ></DatePicker>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                <!-- <v-autocomplete
                    label="Currency"
                    v-model="formSchema.currency"
                    :items="['BDT','USD']"
                    :rules="[v => !!v || 'Currency is required !']"
                    required
                    readonly
                    @change="getCurrencyRate"
                    ></v-autocomplete> -->

                    <v-text-field
                    label="Currency *"
                    v-model="formSchema.currency"
                    readonly
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field
                    label="USD Rate *"
                    v-model="formSchema.usd_rate"
                    :rules="[v => !!v || 'USD rate is required !', spaces, decimal]"
                    required
                    @input="getCurrencyRate"
                    type="number"
                    ></v-text-field>
                  </v-flex> 

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field
                      label="Sub Project Name *"
                      v-model="formSchema.sub_project_name"
                      :rules="[v => !!v || 'Field is required']"
                      readonly
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field
                      label="Total Principal Amount *"
                      v-model="formSchema.principal"
                      :rules="[v => !!v || 'Field is required']"
                      readonly
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field
                      label="Total Interest Amount *"
                      v-model="formSchema.interest"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field
                      label="Total Outstanding *"
                      v-model="formSchema.outstanding"
                      :rules="[v => !!v || 'Field is required']"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field
                      label="Charge"
                      v-model="formSchema.commitment_charge"
                      
                      type="number"
                      @input="getReceivable"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3 class="pr-4" v-show="false">
                    <v-text-field
                      label="Others Charge"
                      v-model="formSchema.others_charge"
                      type="number"
                      @input="getReceivable"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field
                      label="Total Receivable *"
                      v-model="formSchema.receivable"
                      :rules="[v => !!v || 'Field is required']"
                      readonly
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field
                      label="Cheque No"
                      v-model="formSchema.cheque_no"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <DatePicker
                      :key="formSchema.id"
                      :inputData="{index:1,fieldName:'cheque_date', fieldValue:formSchema.cheque_date, label:'Cheque Date'}"
                      @setValue="setDateValue"
                    ></DatePicker>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="info" flat @click.native="close({message:'Form Reseted !',status:1})">
                <v-icon>refresh</v-icon>Reset
              </v-btn>
              <v-btn
                class="success"
                flat
                v-if="userRole.saveButton || userRole.updateButton"
                @click.native="validateBeforeSubmit"
              >
                <v-icon>save</v-icon>Save
              </v-btn>
            </v-card-actions>
          </v-form>

          <hr />
          <table class="paySchedule">
            <tbody>
              <tr class="tb-td">
                <th>Type</th>
                <th style="width: 25%;">Account Name</th>
                <th>TR Debit</th>
                <th>TR Credit</th>
                <th>Currency</th>
                <th>BDT Debit</th>
                <th>BDT Credit</th>
                <th>USD Debit</th>
                <th>USD Credit</th>
                <!-- <th>Src Fund</th> -->
              </tr>
              <!-- __________________ Debit Row _________________ -->
              <tr>
                <td class="textCenter">
                  <input type="text" value="Debit" readonly />
                </td>
                <!-- <td class="textCenter">
                  <input type="text" v-model="debit.eco_code" readonly />
                </td> -->
                <td class="textCenter">
                  <input type="text" v-model="debit.account_name" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="debit.tr_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="debit.tr_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="debit.currency" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="debit.bdt_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="debit.bdt_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="debit.usd_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="debit.usd_credit" readonly />
                </td>
                <!-- <td class="textCenter">
                  <input type="text" v-model="debit.src_fund" readonly />
                </td> -->
              </tr>
              <!-- __________________ /Debit Row _________________ -->

              <!-- __________________ PRINCIPAL Row_________________ -->
              <tr>
                <td class="textCenter">
                  <input type="text" value="Principal" readonly />
                </td>
                <!-- <td class="textCenter">
                  <input type="text" v-model="principal.eco_code" readonly />
                </td> -->
                <td class="textCenter">
                  <input type="text" v-model="principal.account_name" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="principal.tr_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="principal.tr_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="principal.currency" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="principal.bdt_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="principal.bdt_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="principal.usd_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="principal.usd_credit" readonly />
                </td>
                <!-- <td class="textCenter">
                  <input type="text" v-model="principal.src_fund" readonly />
                </td> -->
              </tr>
              <!-- __________________ /PRINCIPAL Row _________________ -->

              <!-- __________________ INTEREST Row_________________ -->
              <tr>
                <td class="textCenter">
                  <input type="text" value="Interest" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="interest.account_name" readonly />
                </td>
                <!-- <td class="textCenter">
                  <input type="text" v-model="interest.eco_code" readonly />
                </td> -->
                
                <td class="textCenter">
                  <input type="text" v-model="interest.tr_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="interest.tr_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="interest.currency" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="interest.bdt_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="interest.bdt_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="interest.usd_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="interest.usd_credit" readonly />
                </td>
                <!-- <td class="textCenter">
                  <input type="text" v-model="interest.src_fund" readonly />
                </td> -->
              </tr>

               <!-- __________________ /INTEREST Row _________________  -->
              <!-- __________________ Commitment Row_________________ -->

              <tr>
                <td class="textCenter">
                  <input type="text" value="Charge" readonly />
                </td>
                <!-- <td class="textCenter">
                  <input type="text" v-model="commitment.eco_code" readonly />
                </td> -->
                <td class="textCenter">
                  <input type="text" v-model="commitment.account_name" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="commitment.tr_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="commitment.tr_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="commitment.currency" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="commitment.bdt_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="commitment.bdt_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="commitment.usd_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="commitment.usd_credit" readonly />
                </td>
                <!-- <td class="textCenter">
                  <input type="text" v-model="commitment.src_fund" readonly />
                </td> -->
              </tr>
              <!-- __________________ /INTEREST Row _________________ -->

              <!-- __________________ Others Row_________________
              <tr>
                <td class="textCenter">
                  <input type="text" value="Others" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="others.eco_code" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="others.account_name" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="others.tr_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="others.tr_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="others.currency" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="others.bdt_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="others.bdt_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="others.usd_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="others.usd_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="others.src_fund" readonly />
                </td>
              </tr> -->
              <!-- __________________ /INTEREST Row _________________ -->

            </tbody>
          </table>
        </v-card>
      </v-flex>
    </v-container>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");
import DatePicker from "../../global/date_picker";

export default {
  components: { DatePicker },

  props: ["formSchema"],

  data: () => ({
    show: false,
    valid: true,
    profileForm: false,
    profileList: [],
    profileDetails: [],
    sub_project_name:'',
    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },

    debit: {
      eco_id:"",
      eco_code: "",
      account_name: "",
      tr_debit: "",
      tr_credit: "",
      currency: "",
      bdt_debit: "",
      bdt_credit: "",
      usd_debit: "",
      usd_credit: "",
      src_fund: "",
      loan_no: "",
      amount_type: "Ins"
    },

    principal: {
      eco_id:"",
      eco_code: "",
      account_name: "",
      tr_debit: "",
      tr_credit: "",
      currency: "",
      bdt_debit: "",
      bdt_credit: "",
      usd_debit: "",
      usd_credit: "",
      src_fund: "",
      loan_no: "",
      amount_type: "P"
    },

    interest: {
      eco_id:"",
      eco_code: "",
      account_name: "",
      tr_debit: "",
      tr_credit: "",
      currency: "",
      bdt_debit: "",
      bdt_credit: "",
      usd_debit: "",
      usd_credit: "",
      src_fund: "",
      loan_no: "",
      amount_type: "I"
    },
    commitment: {
      eco_id:"",
      eco_code: "",
      account_name: "",
      tr_debit: "",
      tr_credit: "",
      currency: "",
      bdt_debit: "",
      bdt_credit: "",
      usd_debit: "",
      usd_credit: "",
      src_fund: "",
      loan_no: "",
      amount_type: "C"
    },
    others: {
      eco_id:"",
      eco_code: "",
      account_name: "",
      tr_debit: "",
      tr_credit: "",
      currency: "",
      bdt_debit: "",
      bdt_credit: "",
      usd_debit: "",
      usd_credit: "",
      src_fund: "",
      loan_no: "",
      amount_type: "OC"
    },

    testData: ""
  }),

  // Page Load After Called Mathodes =========================================
  computed: {
    // User Previlization methods
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    }
  },

  // Page Load Before Called Mathodes =========================================
  created() {
    let root = this;
    // get loan profile
    commonService.getAllData("get_loan_profile_info").then(res => {   
      root.profileList = res.data;
    });
  },

  // Declared Methods for reuse====================================
  methods: {
    // Form submission function
    validateBeforeSubmit(e) {
      let root = this;
      this.Loader = true;
      let formSchema = this.formSchema;
      this.formSchema.settlement_date = this.changeFormateYMD(
        formSchema.installment_date
      );
      this.formSchema.cheque_date = this.changeFormateYMD(
        formSchema.cheque_date
      );
      let formData = new FormData();
      formData.append("formSchema", JSON.stringify(this.formSchema));
      formData.append("debit", JSON.stringify(this.debit));
      if(formSchema.principal > 0){
        formData.append("principal", JSON.stringify(this.principal));
      }
      if(formSchema.interest > 0){
        formData.append("interest", JSON.stringify(this.interest));
      }
      if(formSchema.commitment_charge > 0){
        formData.append("commitment", JSON.stringify(this.commitment));
      }
      if (root.$refs.form.validate()) {
        commonService.insertFormData(formData, "early_settlement").then(res => {
          this.close(res);
          res.status == 1 ? (this.profileForm = false) : "";
        });
      }
    },

    // Get Early settlement form by search=========================
    getEarlySettlementForm() {
      this.setProfileData();
      this.profileForm = true;
      //this.profileDetails = this.formSchema.profile_details;
    },

    // onchange Profile Data
    setProfileData() {
      //From Reset Function
      //this.$refs.form.reset();

      this.profileForm = false;
      var loan_id = this.formSchema.loan_id;
      //Set primary Variable
      var index = this.profileList
        .map(function(e) {
          return e.id;
        })
        .indexOf(loan_id);
        
      var re_schedule_no = this.profileList[index].re_schedule_no;
      var reset_no = this.profileList[index].reset_no;
      var interest_rate = this.profileList[index].interest_rate;

      var sub_project_name = this.profileList[index].sub_project_name;
      
      this.formSchema.re_schedule_no = re_schedule_no;
      this.formSchema.reset_no = reset_no;
      this.formSchema.sub_project_name = sub_project_name;
      this.sub_project_name = sub_project_name // add by bulbul
      
      // Get Voucher Data
      var queryData = {
        'installment_date':  this.changeFormateYMD(this.formSchema.installment_date),
        'loan_id': loan_id,
        'interest_rate': interest_rate
      };
      commonService
        .getServerSideData(queryData, "get_profile_details_data")
        .then(res => {
          if (res.data.outstanding === 0) {
            this.SnackbarVal.message = "Invalid date for early sattlement !!";
            this.SnackbarVal.snackbar = true;
            this.SnackbarVal.color = "error";
            this.profileForm = false;
            
          }

          this.profileDetails = res.data;
          // Voucher Data Preoared
          let voucher = res.data;

          // Total Interest Calculation
          var totalInterest = (parseInt(voucher.extra_interest) + 
                              parseInt(voucher.total_dueInterest) + 
                              parseInt(voucher.total_unpaid_interest)) -
                              (parseInt(voucher.total_partial_interest) + 
                              parseInt(voucher.total_reduce_interest));
          
                              // Total Interest Calculation
          var totalPrincipal = (parseInt(voucher.principal) + 
                                parseInt(voucher.total_unpaid_principal)) -
                                (parseInt(voucher.total_partial_principal));
          
          let formSchema = this.formSchema;
          this.formSchema.details_id = voucher.data.id;
          this.formSchema.currency = voucher.data.currency;
          this.formSchema.loan_details_id = voucher.data.id;
          this.formSchema.installment_no = 0;
          this.formSchema.principal = this.numberFormate(totalPrincipal);
          this.formSchema.main_principal = this.numberFormate(voucher.principal);
          //var totalInterest = parseInt(voucher.interest) + parseInt(formSchema.extra_interest);
          this.formSchema.interest = this.numberFormate(totalInterest);
          this.formSchema.total_Days = this.numberFormate(voucher.total_Days);
          this.formSchema.extra_interest = this.numberFormate(voucher.extra_interest);
          this.formSchema.lastInstallment_date = voucher.data.installment_date;
          this.formSchema.outstanding = this.numberFormate(voucher.outstanding);
          this.formSchema.receivable = this.numberFormate(voucher.outstanding);
          
          this.formSchema.unpaid_installment = res.data.unpaid_installment;
          this.formSchema.partialPayData = res.data.partialPayData;
          this.formSchema.sum_installment = res.data.sum_installment;
          this.formSchema.total_unpaid_principal = res.data.total_unpaid_principal;
          this.formSchema.total_unpaid_interest = res.data.total_unpaid_interest;
          this.formSchema.total_dueInterest = res.data.total_dueInterest;

          this.formSchema.total_partial_principal = res.data.total_partial_principal;
          this.formSchema.total_partial_interest = res.data.total_partial_interest;
          this.formSchema.total_reduce_interest = res.data.total_reduce_interest;

          this.formSchema.loan_no = res.data.data.loan_no;

          //console.log('ddddddddddd', this.formSchema);

          commonService
            .getAllDataById(loan_id, "early_details_collection_info")
            .then(res => {
              // Currancy Rate for voucher entry
              

              let debit = this.debit;
              let principal = this.principal;
              let interest = this.interest;
              let commitment = this.commitment;
              let others = this.others;

              let loanInfo = res.loanInfo;
              let disburstInfo = res.disburstInfo;

              this.formSchema.usd_rate = disburstInfo.currency_rate;

              debit.usd_debit = 0;
              debit.usd_credit = 0;

              principal.usd_debit = 0;
              principal.usd_credit = 0;

              interest.usd_debit = 0;
              interest.usd_credit = 0;

              // Amount Currency rate calculation
              let currency = this.formSchema.currency;
              let usd_rate = this.formSchema.usd_rate;
              let deb = this.numberFormate(this.formSchema.receivable);
              let prin = this.numberFormate(totalPrincipal);
              let int = this.numberFormate(totalInterest);
              let deb_rate = this.currencyChange(deb, currency, usd_rate);
                        
              let prin_rate = this.currencyChange(prin, currency, usd_rate);
              let int_rate = this.currencyChange(int, currency, usd_rate);

              //debit.eco_code = res.debitInfo.debit_eco_code;
              //debit.account_name = res.debitInfo.debit_account_name;
              debit.eco_id = (disburstInfo.fund_source == "IDA") ? loanInfo.Rep_IDA_ACC_ID : loanInfo.Rep_GOB_ACC_ID;
              debit.eco_code = (disburstInfo.fund_source == "IDA") ? loanInfo.Rep_IDA_ACC_CODE : loanInfo.Rep_GOB_ACC_CODE;
              debit.account_name = (disburstInfo.fund_source == "IDA") ? loanInfo.Rep_IDA_ACC_NAME : loanInfo.Rep_GOB_ACC_NAME;
              debit.tr_debit = this.numberFormate(this.formSchema.receivable);
              debit.tr_credit = 0;
              debit.currency = currency;
              debit.bdt_debit = deb_rate.BDT.toFixed(2);
              debit.bdt_credit = 0;
              debit.usd_credit = 0;
              debit.usd_debit = deb_rate.USD.toFixed(2);
              debit.src_fund = disburstInfo.fund_source;
              debit.loan_no = loanInfo.loan_no;

              /*_________________For principal______________*/
              //principal.eco_code = res.creditInfo.credit_eco_code;
              //principal.account_name = res.creditInfo.credit_account_name;
              principal.eco_id =  disburstInfo.economic_code_id;
              principal.eco_code = disburstInfo.eco_account_code;
              principal.account_name = loanInfo.loan_no;
              principal.tr_debit = 0;
              principal.tr_credit = this.numberFormate(totalPrincipal);
              principal.currency = currency;
              principal.bdt_debit = 0;
              principal.bdt_credit = prin_rate.BDT.toFixed(2);
              principal.usd_credit = prin_rate.USD.toFixed(2);
              principal.usd_debit = 0;
              principal.src_fund = disburstInfo.fund_source;
              principal.loan_no = loanInfo.loan_no;
              /*_________________/For principal_____________*/

              /*_________________For interest______________*/
              //interest.eco_code = res.creditInfo.credit_eco_code;
              //interest.account_name = res.creditInfo.credit_account_name;
              interest.eco_id =  disburstInfo.economic_code_id;
              interest.eco_code = disburstInfo.eco_account_code;
              interest.account_name = loanInfo.loan_no;
              interest.tr_debit = 0;
              interest.tr_credit = this.numberFormate(totalInterest);
              interest.currency = currency;
              interest.bdt_debit = 0;
              interest.bdt_credit = int_rate.BDT.toFixed(2);
              interest.usd_credit = int_rate.USD.toFixed(2);
              interest.usd_debit = 0;
              interest.src_fund = disburstInfo.fund_source;
              interest.loan_no = loanInfo.loan_no;
              /*_________________/For interest_____________*/
              
              /*_________________For commitment______________*/
              //commitment.eco_code = res.creditInfo.credit_eco_code;
              //commitment.account_name = res.creditInfo.credit_account_name;
              commitment.eco_id =  disburstInfo.economic_code_id;
              commitment.eco_code = disburstInfo.eco_account_code;
              commitment.account_name = loanInfo.loan_no;
              commitment.tr_debit = 0;
              commitment.tr_credit = this.numberFormate(0);
              commitment.currency = currency;
              commitment.bdt_debit = 0;
              commitment.bdt_credit = this.numberFormate(0);
              commitment.usd_credit = 0;
              commitment.usd_debit = 0;
              commitment.src_fund = disburstInfo.fund_source;
              commitment.loan_no = loanInfo.loan_no;
              /*_________________/For commitment_____________*/

              /*_________________For Others*/
              //others.eco_code = res.creditInfo.credit_eco_code;
              //others.account_name = res.creditInfo.credit_account_name;
              others.eco_id =  disburstInfo.economic_code_id;
              others.eco_code = disburstInfo.eco_account_code;
              others.account_name = loanInfo.loan_no;
              others.tr_debit = 0;
              others.tr_credit = this.numberFormate(0);
              others.currency = currency;
              others.bdt_debit = 0;
              others.bdt_credit = this.numberFormate(0);
              others.usd_credit = 0;
              others.usd_debit = 0;
              others.src_fund = disburstInfo.fund_source;
              others.loan_no = loanInfo.loan_no;
              /*_________________/For others_____________*/
            });

          commonService.getAllData("get-dis-dropdown-data").then(res => {
            this.loanNoList = res.loanNoList;
          });
        });
    },

    getCurrencyRate()
    {

      let formSchema = this.formSchema;

      let debit = this.debit;
      let principal = this.principal;
      let interest = this.interest;
      let commitment = this.commitment;
      let others = this.others;
      
      if(formSchema.currency == 'BDT')
      {
        debit.usd_debit = this.dividedMethodG(debit.tr_debit,formSchema.usd_rate)
        principal.usd_credit = this.dividedMethodG(principal.tr_credit,formSchema.usd_rate)
        interest.usd_credit = this.dividedMethodG(interest.tr_credit,formSchema.usd_rate)
        commitment.usd_credit = this.dividedMethodG(commitment.tr_credit,formSchema.usd_rate)
        others.usd_credit = this.dividedMethodG(others.tr_credit,formSchema.usd_rate)          
      }
      if(formSchema.currency == 'USD')
      { 

        debit.usd_debit = this.multiplyMethodG(debit.tr_debit,formSchema.usd_rate)
        principal.usd_credit = this.multiplyMethodG(principal.tr_credit,formSchema.usd_rate)
        interest.usd_credit = this.multiplyMethodG(interest.tr_credit,formSchema.usd_rate)
        commitment.usd_credit = this.multiplyMethodG(commitment.tr_credit,formSchema.usd_rate)
        others.usd_credit = this.multiplyMethodG(others.tr_credit,formSchema.usd_rate)  
      }
    },

    // onchange getReceivable Form Value
    getReceivable() {
      var currency = this.formSchema.currency;
      var usd_rate = this.formSchema.usd_rate;
      var prev = this.formSchema.outstanding;
      var others = this.formSchema.others_charge;
      var commitment = (this.formSchema.commitment_charge > 0) ? this.formSchema.commitment_charge : 0;
      // Voucher Form commitment & others
      let com = this.commitment;
      let oth = this.others;
      let deb = this.debit;
      oth.tr_credit = this.numberFormate(others);
      com.tr_credit = this.numberFormate(commitment);
      let oth_rate = this.currencyChange(others, currency, usd_rate);
      let com_rate = this.currencyChange(commitment, currency, usd_rate);
      oth.bdt_credit = this.numberFormate(oth_rate.BDT);
      oth.usd_credit = oth_rate.USD.toFixed(2);
      com.bdt_credit = this.numberFormate(com_rate.BDT);
      com.usd_credit = com_rate.USD.toFixed(2);

      var newAmount =
        parseFloat(prev) + parseFloat(commitment) + parseFloat(others);
      if (!isNaN(newAmount)) {
        this.formSchema.receivable = this.numberFormate(newAmount);
        // debit calculation with recievable change
        this.debit.tr_debit = this.numberFormate(newAmount);
        let deb_rate = this.currencyChange(newAmount, currency, usd_rate);
        deb.bdt_debit = this.numberFormate(deb_rate.BDT);
        deb.usd_debit = deb_rate.USD.toFixed(2);
      }
    },
    // Number formating methods
    numberFormate(numBer) {
      if (numBer != "-") {
        //return Number(numBer).toFixed(4);
        return Math.round(numBer);
        //return Math.round(numBer).toLocaleString()+'.00';
      } else {
        return "0.00";
      }
    },
    // Date picker set value
    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
    },
    // Currency Change
    currencyChange(amount, currency, rate) {
      let result = { BDT: "", USD: "" };

      if (currency == "BDT") {
        result.BDT = parseFloat(amount);
        result.USD = parseFloat(amount) / parseFloat(rate);
      }
      if (currency == "USD") {
        result.BDT = parseFloat(amount) * parseFloat(rate);
        result.USD = parseFloat(amount);
      }
      return result;
    },

    printdiv: function () {
          this.printContentStatus = true;
          const divToPrint = document.getElementById("print-area");
          this.printContentStatus = false;
          const newWin = window.open("", "Print-Window");
          newWin.document.open();
          newWin.document.write(
              '<style type="text/css">'+
              'table.paySchedule{ width:100%; border-collapse: collapse; }'+
              '.paySchedule th{ border:1px solid #000; padding: 6px; }'+
              '.paySchedule td{ border:1px solid #000; padding: 6px; }'+
              '.paySchedule tr.tb-td td{font-weight: bold; text-align:center;}'+
              'td.textCenter{text-align: center;}'+
              'td.textRight{text-align: right;}'+
              '#prescriptions_bgImgs{position: absolute; left: 35%; background-repeat: no-repeat;'+
              'background-position: center; background-size: cover; opacity: 0.1; top: 30%; }.paySchedule tr.borderNone td,.paySchedule td.borderNone{border:none !important;}'+
              "</style>"
          );
          newWin.document.write(
              '<html><head><link rel="stylesheet" href="src/assets/css/style.css" type="text/css" /></head><body onload="window.print()">' +
              divToPrint.innerHTML +
              "</body></html>"
          );

          newWin.document.close();
          setTimeout(function () {
              newWin.close();
          }, 3000);
      },

    close: function(message) {
      this.$emit("emitCloseModal", message);
    }
  }
};
</script>

<style scoped>
table.paySchedule {
  width: 100%;
  border-collapse: collapse;
}
.paySchedule th{
  border: 1px solid #CCC;
  text-align: center;
  padding: 0px;
}

.paySchedule td{
  border: 1px solid #CCC;
  line-height: 33px;  
  text-align: center;
  padding: 0px;
}

.paySchedule tr.tb-td td {
  font-weight: bold;
}
td.textCenter {
  text-align: center;
}
td.textRight {
  text-align: right;
}
td input {
  width: 100%;
  text-align: center;
}
.top {
  display: none;
}

</style>


// WEBPACK FOOTER //
// src/components/lending/early_settlement/early_settlement_form.vue